<template>
	<div>
		<loading id="spinner" :active="false" :can-cancel="false" :is-full-page="true"></loading>
		<div class="row">
			<div class="input-field col s12 m12 l2 xl2">
				<select title="Ano do edital" name="ano" id="ano" v-model='edit.ano' required class="browser-default select_sec" :disabled="this.readonly==true">
					<option value="" disabled selected>Ano</option>
					<option v-for="ano in this.listaAnos" :value=ano>{{ano}}</option>
				</select>
			</div>
			<div class="input-field col s12 m12 l2 xl2">
				<input title="Apenas o número do edital (valor entre 1 e 999)" type="number" id="numero" name="numero" v-model='edit.numero' min="1" max="999" required class="validate" :disabled="this.readonly==true">
				</input>
				<label for="numero">Numero</label>
			</div>
			<div class="input-field col s12 m12 l2 xl2">
				<input title="Informe a siac anterior" type="text"
				 	id="siac_anterior"
					name="siac_anterior"
					placeholder="Ex:siac10"
					maxlength="10"
					v-model='edit.siac_anterior' 
					required class="validate" :disabled="this.readonly==true">
				</input>
				<label for="numero">Siac Anterior</label>
			</div>
			<div hidden class="input-field col s12 m12 l3 xl3">
				<input title="Número máximo de ações por solicitação (valor entre 1 e 99)" type="number" id="max_inscricoes" name="max_inscricoes" v-model='edit.max_inscricoes' min="1" max="99" class="validate" :disabled="this.readonly==true">
				</input>
				<label for="max_inscricoes">Máximo de ações</label>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Tempo minimo de permanência do bolsista na ação em dias" type="number" id="min_dias_bolsista" name="min_dias_bolsista" v-model='edit.min_dias_bolsista' required class="validate" min="0" max="99" required :disabled="this.readonly==true">
				</input>
				<label for="min_dias_bolsista">Tempo mínimo do bolsista</label>
			</div>
		</div>
		
		<div class="row">
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Período de inscrição</label>
			</div>
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Análise técnica</label>
			</div>
		</div>
		<div class="row">
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_inscricao" name="ini_inscricao" v-model='edit.ini_inscricao' required class="validate" v-on:focusout="validarDatas(0)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_inscricao" name="fim_inscricao" v-model='edit.fim_inscricao' required class="validate" v-on:focusout="validarDatas(0)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_pert_ind" name="ini_pert_ind" v-model='edit.ini_pert_ind' required class="validate" v-on:focusout="validarDatas(2)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_pert_ind" name="fim_pert_ind" v-model='edit.fim_pert_ind' required class="validate" v-on:focusout="validarDatas(2)" :disabled="this.readonly==true">
				</input>
			</div>
		</div>
		
		<div class="row">
			<!--div class="input-field col s12 m12 l6 xl6">	
				<label>Avaliação da pertinência das ações pela comissão</label>
			</div-->
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Resultado preliminar da análise técnica</label>
			</div>
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Período para cumprimento de exigência</label>
			</div>
		</div>
		<div class="row">
			<!--div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_pert_com" name="ini_pert_com" v-model='edit.ini_pert_com' required class="validate" v-on:focusout="validarDatas(4)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_pert_com" name="fim_pert_com" v-model='edit.fim_pert_com' required class="validate" v-on:focusout="validarDatas(4)" :disabled="this.readonly==true">
				</input>
			</div-->
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_res_pert_ini" name="ini_res_pert_ini" v-model='edit.ini_res_pert_ini' required class="validate" v-on:focusout="validarDatas(4)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_res_pert_ini" name="fim_res_pert_ini" v-model='edit.fim_res_pert_ini' required class="validate" v-on:focusout="validarDatas(4)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_int_rec_pert" name="ini_int_rec_pert" v-model='edit.ini_int_rec_pert' required class="validate" v-on:focusout="validarDatas(6)" :disabled="this.readonly==true">
				</input>	
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_int_rec_pert" name="fim_int_rec_pert" v-model='edit.fim_int_rec_pert' required class="validate" v-on:focusout="validarDatas(6)" :disabled="this.readonly==true">
				</input>
			</div>
		</div>
		
		<div class="row">
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Análise das exigências</label>
			</div>
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Resultado final da análise técnica</label>
			</div>
		</div>	
		<div class="row">
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_ana_rec_pert" name="ini_ana_rec_pert" v-model='edit.ini_ana_rec_pert' required class="validate" v-on:focusout="validarDatas(8)" :disabled="this.readonly==true">
				</input>	
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_ana_rec_pert" name="fim_ana_rec_pert" v-model='edit.fim_ana_rec_pert' required class="validate" v-on:focusout="validarDatas(8)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_res_pert_fim" name="ini_res_pert_fim" v-model='edit.ini_res_pert_fim' required class="validate" v-on:focusout="validarDatas(10)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_res_pert_fim" name="fim_res_pert_fim" v-model='edit.fim_res_pert_fim' required class="validate" v-on:focusout="validarDatas(10)" :disabled="this.readonly==true">
				</input>
			</div>
		</div>
		
		<div class="row">
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Distribuição das ações aos avaliadores</label>
			</div>
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Avaliação das solicitações pelos proponentes</label>
			</div>
		</div>	
		<div class="row">
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_dist_aval" name="ini_dist_aval" v-model='edit.ini_dist_aval' required class="validate" v-on:focusout="validarDatas(12)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_dist_aval" name="fim_dist_aval" v-model='edit.fim_dist_aval' required class="validate" v-on:focusout="validarDatas(12)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_aval_sol_prop" name="ini_aval_sol_prop" v-model='edit.ini_aval_sol_prop' required class="validate" v-on:focusout="validarDatas(14)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_aval_sol_prop" name="fim_aval_sol_prop" v-model='edit.fim_aval_sol_prop' required class="validate" v-on:focusout="validarDatas(14)" :disabled="this.readonly==true">
				</input>
			</div>
		</div>
		
		<div class="row">
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Justificativa para não avaliação de ações</label>
			</div>
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Verificação de discrepância pela comissão</label>
			</div>
		</div>	
		<div class="row">
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_just_nao_aval" name="ini_just_nao_aval" v-model='edit.ini_just_nao_aval' required class="validate" v-on:focusout="validarDatas(16)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_just_nao_aval" name="fim_just_nao_aval" v-model='edit.fim_just_nao_aval' required class="validate" v-on:focusout="validarDatas(16)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_ver_disc" name="ini_ver_disc" v-model='edit.ini_ver_disc' required class="validate" v-on:focusout="validarDatas(18)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_ver_disc" name="fim_ver_disc" v-model='edit.fim_ver_disc' required class="validate" v-on:focusout="validarDatas(18)" :disabled="this.readonly==true">
				</input>
			</div>
		</div>
		
		<div class="row">
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Reavaliação das ações discrepantes</label>
			</div>
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Divulgação do resultado preliminar</label>
			</div>
			
		</div>	
		<div class="row">
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_seg_aval" name="ini_seg_aval" v-model='edit.ini_seg_aval' required class="validate" v-on:focusout="validarDatas(20)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_seg_aval" name="fim_seg_aval" v-model='edit.fim_seg_aval' required class="validate" v-on:focusout="validarDatas(20)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_res_ini" name="ini_res_ini" v-model='edit.ini_res_ini' required class="validate" v-on:focusout="validarDatas(22)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_res_ini" name="fim_res_ini" v-model='edit.fim_res_ini' required class="validate" v-on:focusout="validarDatas(22)" :disabled="this.readonly==true">
				</input>
			</div>
			
		</div>
		<div class="row">
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Interposição de recursos</label>
			</div>
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Análise dos recursos</label>
			</div>
		</div>	
		<div class="row">
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_int_rec_res" name="ini_int_rec_res" v-model='edit.ini_int_rec_res' required class="validate" v-on:focusout="validarDatas(24)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_int_rec_res" name="fim_int_rec_res" v-model='edit.fim_int_rec_res' required class="validate" v-on:focusout="validarDatas(24)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_ana_rec_res" name="ini_ana_rec_res" v-model='edit.ini_ana_rec_res' required class="validate" v-on:focusout="validarDatas(26)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_ana_rec_res" name="fim_ana_rec_res" v-model='edit.fim_ana_rec_res' required class="validate" v-on:focusout="validarDatas(26)" :disabled="this.readonly==true">
				</input>
			</div>
		</div>
		<div class="row">
			
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Divulgação do resultado final</label>
			</div>
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Registro das bolsas na plataforma</label>
			</div>
		</div>
		<div class="row">
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_res_final" name="ini_res_final" v-model='edit.ini_res_final' required class="validate" v-on:focusout="validarDatas(28)" :disabled="this.readonly==true">
				</input>	
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_res_final" name="fim_res_final" v-model='edit.fim_res_final' required class="validate" v-on:focusout="validarDatas(28)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_bolsas" name="ini_bolsas" v-model='edit.ini_bolsas' required class="validate" v-on:focusout="validarDatas(30)" :disabled="this.readonly==true">
				</input>
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_bolsas" name="fim_bolsas" v-model='edit.fim_bolsas' required class="validate" v-on:focusout="validarDatas(30)" :disabled="this.readonly==true">
				</input>
			</div>
		</div>
		
		<div class="row">
			<div class="input-field col s12 m12 l6 xl6">	
				<label>Prazo de envio dos relatórios</label>
			</div>
		</div>
		<div class="row">
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data inicial" type="date" id="ini_relat" name="ini_relat" v-model='edit.ini_relat' required class="validate" v-on:focusout="validarDatas(32)" :disabled="this.readonly==true">
				</input>	
			</div>
			<div class="input-field col s12 m12 l3 xl3">
				<input title="Data final" type="date" id="fim_relat" name="fim_relat" v-model='edit.fim_relat' required class="validate" v-on:focusout="validarDatas(32)" :disabled="this.readonly==true">
				</input>
			</div>
		</div>
		
		<div class="row">
			<div v-if="!this.readonly" class="file-field input-field col s12 m12 l6 xl6">	
				<div class="btn">
					<span>PDF do edital</span>
					<input type="file" title="PDF do edital" :id="'/editals/pdf/' + edit.ano" accept="application/pdf" :required='!edit.id' class="validate">
					</input>
				</div>
				<div class="file-path-wrapper">
					<input class="file-path validate" type="text">
				</div>
			</div>
			<div class="input-field col s12 m12 l6 xl6">	
				<a class="btn" :href="'/editals/pdf/' + (edit.ano? edit.ano : 0)" target='_blank'><i class="material-icons left">assignment_returned</i>PDF do edital</a>
			</div>
		</div>
		
		<div class="row">
			<div v-if="!this.readonly" class="file-field input-field col s12 m12 l6 xl6">	
				<div class="btn">
					<span>Logo do sistema</span>
					<input type="file" title="Logo do sistema" :id="'/editals/logo/' + edit.ano" accept="image/*" :required='!edit.id' class="validate">
					</input>
				</div>
				<div class="file-path-wrapper">
					<input class="file-path validate" type="text">
				</div>
			</div>
		</div>
		
		<div class="row">
			<div class="input-field col s6 m6 l3 xl3">
				<button v-if="!this.readonly" type="submit" class="btn" id='submit'>
					<i class="material-icons left">save</i>Salvar
				</button>
			</div>
			<div class="input-field col s6 m6 l3 xl3">
				<button v-if="!edit.id" type="reset" class="btn indigo">
					<i class="material-icons right">clear</i>Limpar
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
		name: "VueEditalForm",
		props: [
			'edital',
			'anos', 
			'readonly'
		],
		components: {
            Loading
        },
		data () {
			return {
				edit: JSON.parse(this.edital),
				listaAnos: JSON.parse(this.anos)
			}
		},
		mounted() {
			if (this.edit.id) {
				var datas = document.querySelectorAll('input[type=date]'),
					tamanho = datas.length,
					data;
				while (--tamanho >= 0) {
					data = datas[tamanho].id;
					this.edit[data] = this.edit[data].substring(0, 10);
				}
			}
        },
		methods: {
			validarDatas(i) {
				var datas = document.querySelectorAll('input[type=date]');
				var dataIni = datas[i];
				var dataFim = datas[i + 1];
				if (dataIni.value.length != 10) {
					dataIni.classList.remove("valid");
					dataIni.classList.add("invalid");
					document.getElementById('submit').disabled = true;
					showMsg('A data inicial está inválida!', 0);
				}
				else if (dataFim.value.length != 10) {
					dataFim.classList.remove("valid");
					dataFim.classList.add("invalid");
					document.getElementById('submit').disabled = true;
					showMsg('A data final está inválida!', 0);
				}
				else if (dataIni.value && dataFim.value) {
					if (new Date(dataIni.value).getTime() > new Date(dataFim.value).getTime()) {
						dataIni.classList.remove("valid");
						dataFim.classList.remove("valid");
						dataIni.classList.add("invalid");
						dataFim.classList.add("invalid");
						document.getElementById('submit').disabled = true;
						showMsg('A data inicial precisa não pode ser maior do que a final!', 0);
					} else {
						dataIni.classList.remove("invalid");
						dataFim.classList.remove("invalid");
						dataIni.classList.add("valid");
						dataFim.classList.add("valid");
						document.getElementById('submit').disabled = false;
					}
				}
			}	
		}
    }

</script>
